import { AsyncActionHandler } from 'action-handler';
import { handleCommsError } from 'action-utils';

export default new AsyncActionHandler({
  name: 'trigger_wifi_connect',
  stateProp: 'triggerWifiConnect',
  handler: () => async (dispatch) => {
    let response;

    try {
      response = await window.__webview_comms__.trigger('wifi-connect');
    } catch (errorData) {
      response = errorData;
    }
    const { 'wifi-connected-status': wifiConnectedStatus, error } = response;

    if (wifiConnectedStatus === true) {
      return;
    }

    handleCommsError(dispatch, 'wifi-connect', error);

    throw new Error(`TRIGGER:wifi-connect error: ${error}`);
  }
});
